'use strict';

var _classCallCheck = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RequestClient = require('./RequestClient');

var getName = function getName(id) {
  return id.split('-').map(function (s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }).join(' ');
};

module.exports = /*#__PURE__*/function (_RequestClient) {
  _inherits(SearchProvider, _RequestClient);

  var _super = _createSuper(SearchProvider);

  function SearchProvider(uppy, opts) {
    var _this;

    _classCallCheck(this, SearchProvider);

    _this = _super.call(this, uppy, opts);
    _this.provider = opts.provider;
    _this.id = _this.provider;
    _this.name = _this.opts.name || getName(_this.id);
    _this.pluginId = _this.opts.pluginId;
    return _this;
  }

  _createClass(SearchProvider, [{
    key: "fileUrl",
    value: function fileUrl(id) {
      return "".concat(this.hostname, "/search/").concat(this.id, "/get/").concat(id);
    }
  }, {
    key: "search",
    value: function search(text, queries) {
      queries = queries ? "&".concat(queries) : '';
      return this.get("search/".concat(this.id, "/list?q=").concat(encodeURIComponent(text)).concat(queries));
    }
  }]);

  return SearchProvider;
}(RequestClient);